import get from 'lodash/get';

import { parsePhoneNumber } from '@vmos2/utils';
import { getDistanceLatLng } from '@vmos2/location';

export const getAddressStructure = (address, storeLat, storeLong, phonePrefixSetting, phoneNumberFallback) => {
  const {
    address: { address1, address2, town, country: county, postcode, location },
    instructions: { phoneNumber, deliveryInstructions }
  } = address;

  const phone = parsePhoneNumber(phoneNumber);
  const defaultParsedPhone = parsePhoneNumber(phoneNumberFallback);

  const defaultPhonePrefix = defaultParsedPhone.prefix ? defaultParsedPhone.prefix.toString() : phonePrefixSetting.toString();
  const phoneNumberString = phone.phone ? phone.phone.toString() : null;
  const phonePrefix = phone.prefix ? phone.prefix.toString() : defaultPhonePrefix.toString();

  const distance = getDistanceLatLng(get(location, 'lat'), get(location, 'long'), storeLat, storeLong);

  return {
    checkoutAddress: {
      searchAddress: address1,
      address1,
      address2,
      town,
      county,
      postCode: postcode,
      searchPostCode: postcode,
      phoneNumber: phoneNumberString,
      phonePrefix,
      instructions: deliveryInstructions,
      distance,
      latitude: get(location, 'lat'),
      longitude: get(location, 'long'),
    }
  };
};
